import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import DonateHeader from "../components/donate/donateheader"
import DonateIntro from "../components/donate/donateintro"


const Visit = () => (
  <Layout>
    <SEO title="Donate to Fairview Farmers Market" />
    <DonateHeader />
    <DonateIntro />
  </Layout>
)

export default Visit
